export default __webpack_public_path__ + "static/media/tree.52b6e502.glb";